import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-53ef92f6")

_pushScopeId("data-v-53ef92f6")
const _hoisted_1 = { class: "card" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createVNode("div", { class: "card-header-title" }, [
    /*#__PURE__*/_createVNode("p", { class: "title is-4" }, "ATB Informationen")
  ])
], -1)
const _hoisted_3 = { class: "card-content" }
const _hoisted_4 = { class: "content" }
const _hoisted_5 = /*#__PURE__*/_createVNode("p", { class: "subtitle is-5" }, "Shipment", -1)
const _hoisted_6 = { class: "columns is-gapless is-mobile" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "column is-on-third" }, [
  /*#__PURE__*/_createVNode("p", { class: "subtitle is-6" }, "Tracking No.:")
], -1)
const _hoisted_8 = { class: "column" }
const _hoisted_9 = { class: "subtitle is-6" }
const _hoisted_10 = { class: "columns is-gapless is-mobile" }
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "column is-on-third" }, [
  /*#__PURE__*/_createVNode("p", { class: "subtitle is-6" }, "BAL B/L / SWB No.:")
], -1)
const _hoisted_12 = { class: "column" }
const _hoisted_13 = { class: "subtitle is-6" }
const _hoisted_14 = /*#__PURE__*/_createVNode("p", { class: "subtitle is-5" }, "Container Details", -1)
const _hoisted_15 = { class: "columns is-gapless is-mobile" }
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "column is-on-third" }, [
  /*#__PURE__*/_createVNode("p", { class: "subtitle is-6" }, "Schiff:")
], -1)
const _hoisted_17 = { class: "column" }
const _hoisted_18 = { class: "subtitle is-6" }
const _hoisted_19 = { class: "columns is-gapless is-mobile" }
const _hoisted_20 = /*#__PURE__*/_createVNode("div", { class: "column is-on-third" }, [
  /*#__PURE__*/_createVNode("p", { class: "subtitle is-6" }, "Container:")
], -1)
const _hoisted_21 = { class: "column" }
const _hoisted_22 = { class: "subtitle is-6" }
const _hoisted_23 = { class: "columns is-gapless is-mobile" }
const _hoisted_24 = /*#__PURE__*/_createVNode("div", { class: "column is-on-third" }, [
  /*#__PURE__*/_createVNode("p", { class: "subtitle is-6" }, "ETA:")
], -1)
const _hoisted_25 = { class: "column" }
const _hoisted_26 = { class: "subtitle is-6" }
const _hoisted_27 = { class: "columns is-gapless is-mobile" }
const _hoisted_28 = /*#__PURE__*/_createVNode("div", { class: "column is-on-third" }, [
  /*#__PURE__*/_createVNode("p", { class: "subtitle is-6" }, "Entladestation:")
], -1)
const _hoisted_29 = { class: "column" }
const _hoisted_30 = { class: "subtitle is-6" }
const _hoisted_31 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_32 = /*#__PURE__*/_createVNode("p", { class: "subtitle is-5" }, "Cargo Details", -1)
const _hoisted_33 = { class: "columns is-gapless is-mobile" }
const _hoisted_34 = /*#__PURE__*/_createVNode("div", { class: "column is-on-third" }, [
  /*#__PURE__*/_createVNode("p", { class: "subtitle is-6" }, "Kolli:")
], -1)
const _hoisted_35 = { class: "column" }
const _hoisted_36 = { class: "subtitle is-6" }
const _hoisted_37 = { class: "columns is-gapless is-mobile" }
const _hoisted_38 = /*#__PURE__*/_createVNode("div", { class: "column is-on-third" }, [
  /*#__PURE__*/_createVNode("p", { class: "subtitle is-6" }, "Europaletten:")
], -1)
const _hoisted_39 = { class: "column" }
const _hoisted_40 = { class: "subtitle is-6" }
const _hoisted_41 = { class: "columns is-gapless is-mobile" }
const _hoisted_42 = /*#__PURE__*/_createVNode("div", { class: "column is-on-third" }, [
  /*#__PURE__*/_createVNode("p", { class: "subtitle is-6" }, "Einwegpaletten:")
], -1)
const _hoisted_43 = { class: "column" }
const _hoisted_44 = { class: "subtitle is-6" }
const _hoisted_45 = { class: "columns is-gapless is-mobile" }
const _hoisted_46 = /*#__PURE__*/_createVNode("div", { class: "column is-on-third" }, [
  /*#__PURE__*/_createVNode("p", { class: "subtitle is-6" }, "Gewicht:")
], -1)
const _hoisted_47 = { class: "column" }
const _hoisted_48 = { class: "subtitle is-6" }
const _hoisted_49 = /*#__PURE__*/_createVNode("p", { class: "subtitle is-5" }, "ATB Details", -1)
const _hoisted_50 = { class: "columns is-gapless is-mobile" }
const _hoisted_51 = /*#__PURE__*/_createVNode("div", { class: "column is-on-third" }, [
  /*#__PURE__*/_createVNode("p", { class: "subtitle is-6" }, "Nummer:")
], -1)
const _hoisted_52 = { class: "column" }
const _hoisted_53 = { class: "subtitle is-6" }
const _hoisted_54 = { class: "columns is-gapless is-mobile" }
const _hoisted_55 = /*#__PURE__*/_createVNode("div", { class: "column is-on-third" }, [
  /*#__PURE__*/_createVNode("p", { class: "subtitle is-6" }, "Position:")
], -1)
const _hoisted_56 = { class: "column" }
const _hoisted_57 = { class: "subtitle is-6" }
const _hoisted_58 = { class: "columns is-gapless is-mobile" }
const _hoisted_59 = /*#__PURE__*/_createVNode("div", { class: "column is-on-third" }, [
  /*#__PURE__*/_createVNode("p", { class: "subtitle is-6" }, "Entladedatum:")
], -1)
const _hoisted_60 = { class: "column" }
const _hoisted_61 = { class: "subtitle is-6" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode("div", _hoisted_6, [
          _hoisted_7,
          _createVNode("div", _hoisted_8, [
            _createVNode("p", _hoisted_9, _toDisplayString(_ctx.info.trackingNumber), 1)
          ])
        ]),
        _createVNode("div", _hoisted_10, [
          _hoisted_11,
          _createVNode("div", _hoisted_12, [
            _createVNode("p", _hoisted_13, _toDisplayString(_ctx.info.exportFileReference), 1)
          ])
        ]),
        _hoisted_14,
        _createVNode("div", _hoisted_15, [
          _hoisted_16,
          _createVNode("div", _hoisted_17, [
            _createVNode("p", _hoisted_18, _toDisplayString(_ctx.info.container.vessel), 1)
          ])
        ]),
        _createVNode("div", _hoisted_19, [
          _hoisted_20,
          _createVNode("div", _hoisted_21, [
            _createVNode("p", _hoisted_22, _toDisplayString(_ctx.info.container.number), 1)
          ])
        ]),
        _createVNode("div", _hoisted_23, [
          _hoisted_24,
          _createVNode("div", _hoisted_25, [
            _createVNode("p", _hoisted_26, _toDisplayString(_ctx.formatDate(_ctx.info.container.eta)), 1)
          ])
        ]),
        _createVNode("div", _hoisted_27, [
          _hoisted_28,
          _createVNode("div", _hoisted_29, [
            _createVNode("p", _hoisted_30, [
              _createTextVNode(_toDisplayString(_ctx.info.container.cfs) + " ", 1),
              _hoisted_31,
              _createTextVNode(_toDisplayString(_ctx.info.container.cfsAddress), 1)
            ])
          ])
        ]),
        _hoisted_32,
        _createVNode("div", _hoisted_33, [
          _hoisted_34,
          _createVNode("div", _hoisted_35, [
            _createVNode("p", _hoisted_36, _toDisplayString(_ctx.info.cargo.numberOfPieces), 1)
          ])
        ]),
        _createVNode("div", _hoisted_37, [
          _hoisted_38,
          _createVNode("div", _hoisted_39, [
            _createVNode("p", _hoisted_40, _toDisplayString(_ctx.info.cargo.euroPLT), 1)
          ])
        ]),
        _createVNode("div", _hoisted_41, [
          _hoisted_42,
          _createVNode("div", _hoisted_43, [
            _createVNode("p", _hoisted_44, _toDisplayString(_ctx.info.cargo.onewayPLT), 1)
          ])
        ]),
        _createVNode("div", _hoisted_45, [
          _hoisted_46,
          _createVNode("div", _hoisted_47, [
            _createVNode("p", _hoisted_48, _toDisplayString(_ctx.info.cargo.weight), 1)
          ])
        ]),
        _hoisted_49,
        _createVNode("div", _hoisted_50, [
          _hoisted_51,
          _createVNode("div", _hoisted_52, [
            _createVNode("p", _hoisted_53, _toDisplayString(_ctx.info.details.number), 1)
          ])
        ]),
        _createVNode("div", _hoisted_54, [
          _hoisted_55,
          _createVNode("div", _hoisted_56, [
            _createVNode("p", _hoisted_57, _toDisplayString(_ctx.info.details.position), 1)
          ])
        ]),
        _createVNode("div", _hoisted_58, [
          _hoisted_59,
          _createVNode("div", _hoisted_60, [
            _createVNode("p", _hoisted_61, _toDisplayString(_ctx.formatDate(_ctx.info.details.unloadingDate)), 1)
          ])
        ])
      ])
    ])
  ]))
})